// extracted by css-extract-rspack-plugin
module.exports =  {"candidateInfo":"Okcuh","topInfo":"GQZUF","infoRow":"HlBuj","infoCol":"zNBQk"};